<div class="row filter-type-selection-header">
  <div class="col-12">Enter one or more IDs, comma delimited</div>
</div>
<div class="row">
  <div class="col-12">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(bvdId) }">
      <span class="ey-float-label">
        <input
          type="text"
          class="form-control"
          id="bvdId"
          name="bvdId"
          [(ngModel)]="filter.bvdId"
          [disabled]="readOnly"
          #bvdId="ngModel"
          maxlength="41999"
          pattern="{{ regularExpressionPattern.BvdIdPattern }}"
          (blur)="filter.bvdId = removeWhitespace(filter.bvdId)"
          [appBvdIdsLimit]="bvdIdNumbersLimit"
          required
          appLabelFloat
          (click)="formDirty = true"
        />
        <label for="bvdId">ID Number</label>
      </span>
      <input type="hidden" [(ngModel)]="filter.bvdId" name="bvdId" #bvdId="ngModel" required />
      <span class="help-block" *ngIf="formDirty && bvdId.invalid && ShowValidationMessage(bvdId) && bvdId.errors.required">
        Please enter ID Number.
      </span>
      <span class="help-block" *ngIf="formDirty && bvdId.invalid && bvdId.errors?.pattern">
        ID Number can only contain upper-case letters and numbers, astrix, comma and dash.
      </span>
      <span class="help-block" *ngIf="formDirty && bvdId.invalid && bvdId.errors?.appBvdIdsLimit">
        Maximum {{ bvdIdNumbersLimit }} ID's allowed.
      </span>
    </div>
  </div>
</div>
